export class HowToCard {
  title: string;
  body: any;
  imageUrl: string;
  imageAlt: string;

  constructor(title: string, body: any, imageUrl = '', imageAlt = '') {
    this.title = title;
    this.body = body;
    this.imageUrl = imageUrl;
    this.imageAlt = imageAlt;
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/models/howToCard.ts